import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Text } from '.';
import { useTheme } from '@emotion/react';
const Hr = ({ children, ...props }) => {
    const theme = useTheme();
    const baseStyle = {
        height: 0,
        border: 'none',
        borderBottom: `1px solid ${theme.color.outlineVariant}`,
    };
    if (!children) {
        return _jsx("hr", { ...props, css: baseStyle });
    }
    return (_jsxs("div", { ...props, css: { display: 'flex', alignItems: 'center', gap: '1.6rem' }, children: [_jsx("div", { css: [baseStyle, { flex: 1 }] }), _jsx(Text.Body, { children: children }), _jsx("div", { css: [baseStyle, { flex: 1 }] })] }));
};
export default Hr;
//# sourceMappingURL=Hr.js.map